import { render, staticRenderFns } from "./moduleFifteen.vue?vue&type=template&id=654b8221&scoped=true&"
import script from "./moduleFifteen.vue?vue&type=script&lang=js&"
export * from "./moduleFifteen.vue?vue&type=script&lang=js&"
import style0 from "./moduleFifteen.vue?vue&type=style&index=0&id=654b8221&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b8221",
  null
  
)

export default component.exports